import { render, staticRenderFns } from "./TaxabilitySearch.vue?vue&type=template&id=edcc244a&scoped=true"
import script from "./TaxabilitySearch.vue?vue&type=script&lang=ts"
export * from "./TaxabilitySearch.vue?vue&type=script&lang=ts"
import style0 from "./TaxabilitySearch.vue?vue&type=style&index=0&id=edcc244a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edcc244a",
  null
  
)

export default component.exports